import { DateAdapter } from '@/data/protocols'

export const TICKET_FILTER_DATE_FORMAT = 'YYYY-MM-DD'

const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/
const LEGACY_DATE_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/
const DATE_STRING_PATTERN = /GMT[+-]\d{4}/

const isValidDate = (date: Date): boolean => {
  return date instanceof Date && !Number.isNaN(date.getTime())
}

const dateFromParts = (year: number, month: number, day: number): Date | null => {
  const date = new Date(year, month - 1, day)

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null
  }

  return date
}

const parseLegacyDate = (value: string): Date | null => {
  const match = LEGACY_DATE_PATTERN.exec(value)

  if (!match) {
    return null
  }

  const [, day, month, year] = match
  return dateFromParts(Number(year), Number(month), Number(day))
}

export const normalizeTicketFilterDate = (
  dateAdapter: DateAdapter,
  value: string,
  fallback: Date
): string => {
  const fallbackValue = dateAdapter.format(fallback, TICKET_FILTER_DATE_FORMAT)

  if (!value) {
    return fallbackValue
  }

  const legacyDate = parseLegacyDate(value)

  if (legacyDate) {
    return dateAdapter.format(legacyDate, TICKET_FILTER_DATE_FORMAT)
  }

  if (!ISO_DATE_PATTERN.test(value) && !DATE_STRING_PATTERN.test(value)) {
    return fallbackValue
  }

  const parsedDate = dateAdapter.parse(value)

  return isValidDate(parsedDate)
    ? dateAdapter.format(parsedDate, TICKET_FILTER_DATE_FORMAT)
    : fallbackValue
}
